import { isMembershipPerspective } from '@center-platform/spheres/sphere';
import type { SphereSectionSlot } from '../SphereEditor/sphereSectionSlots';
import SphereMembersOrganism from './SphereMembersOrganism';

/** The Members tab: only for a saved sphere whose schema has a perspective someone can be assigned to. */
export const membersSectionSlot: SphereSectionSlot = {
  appliesTo: (ctx) => !!ctx.sphere.id && (ctx.schemaType.perspectives ?? []).some(isMembershipPerspective),
  Component: SphereMembersOrganism,
};
